import React from "react";
import { Autocomplete, Box, Button, ListItem, MenuItem, TextField } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useAuth } from "../../../../../auth/auth";
import { editUserOnBoardingForm } from "../../../../../api/apiCall";
import { toast } from "react-toastify";

const EditOnboardingForm = ({
    profileInfo,
    id,
    onboardingForms,
    selectedOnboardingForm,
    setSelectedOnboardingForm,
    expDate,
    setExpDate,
    onboardingFormStatus,
    setOnboardingFormStatus,
    setIsModalEditOnboardingFormOpen,
    getWorkerInfo,
}: any) => {
    const {state} = useAuth();

    const editOnboardingForm = async () => {
        const response = await editUserOnBoardingForm(state.user?.token, {
            userId: profileInfo.id,
            id: id,
            onBoardingFormTypeId: selectedOnboardingForm.id,
            expDate: expDate,
            approvedById: state.user?.id,
            status: onboardingFormStatus,
        })
        if(response) {
            setIsModalEditOnboardingFormOpen(false);
            toast.success('Onboarding form edited successfully');
            getWorkerInfo();
        }
    }
        
    return (
        <Box display="grid" gridTemplateColumns={{xs: "1fr", md: "1fr"}} gap={4} mt={4}>
            <Autocomplete
                size="small"
                disabled
                options={onboardingForms}
                value={onboardingForms.find((form: any) => form.id === selectedOnboardingForm) || selectedOnboardingForm}
                onChange={(_, newValue) => {
                    setSelectedOnboardingForm(newValue)
                }}
                getOptionLabel={(option: any) => option.name}
                renderOption={(props, option) => (
                    <ListItem {...props} key={option.name}>
                      {option.name}
                    </ListItem>
                )}
                renderInput={(params) => (
                    <TextField {...params} label="Onboarding Form" placeholder="Select Onboarding Form" />
                )}
            />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                    <DatePicker
                        slotProps={{ textField: { size: 'small', fullWidth: true } }}
                        label="Expiration Date"
                        format="DD/MM/YYYY"
                        value={expDate ? dayjs(expDate) : null}
                        onChange={(value) => {
                            setExpDate(value ? value.toISOString() : null);
                        }}
                    />
                </DemoContainer>
            </LocalizationProvider>
            <TextField
                select
                value={onboardingFormStatus}
                id="demo-select-small"
                size="small"
                label="Status"
                sx={{mb: 2}}
                onChange={(e: any) => {setOnboardingFormStatus(e.target.value)}}
            >
                <MenuItem value={0}>Pending</MenuItem>
                <MenuItem value={1}>Approved</MenuItem>
                <MenuItem value={2}>Denied</MenuItem>
                <MenuItem value={3}>Not Verified</MenuItem>
            </TextField>
            <div className="center-button-div">
                <Button variant="contained" sx={{boxShadow: 'none'}} onClick={editOnboardingForm}>
                    Edit Onboarding Form
                </Button>
            </div>
        </Box>
    )
}

export default EditOnboardingForm;
